/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { createTheme } from '@mui/material/styles';
import pearsonTheme from '@greenville/mui-theme';
import mixins from '../../../assets/styles/mixins.scss';

const plusSansPrimary = mixins.fontFamilyPlusSansPrimary;

const typographyStyleOverride = {
  fontFamily: plusSansPrimary
};

const buttonTextTransformNone = {
  textTransform: 'none'
};

const muiTheme = createTheme(pearsonTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.MuiButtonBase-root.MuiButton-root': buttonTextTransformNone
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          ...typographyStyleOverride,
          ...buttonTextTransformNone,
          '& .MuiTouchRipple-root': {
            display: 'none'
          }
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          border: '2px solid rgba(0, 0, 0, 0)',
          color: mixins.indigoDefaultColor,
          fontFamily: plusSansPrimary,
          ...buttonTextTransformNone,
          '&.MuiButton-text': {
            color: mixins.indigoDefaultColor,
            background: 'transparent',
            backgroundColor: 'transparent',
            '&:hover': {
              color: mixins.indigoDefaultColor,
              background: mixins.colorFooterBg,
              backgroundColor: mixins.colorFooterBg
            }
          }
        },
        text: {
          ...buttonTextTransformNone,
          background: 'transparent',
          backgroundColor: 'transparent',
          '&:hover': {
            background: mixins.colorFooterBg,
            backgroundColor: mixins.colorFooterBg
          }
        },
        outlined: buttonTextTransformNone,
        contained: buttonTextTransformNone,
        textPrimary: {
          ...buttonTextTransformNone,
          color: mixins.indigoDefaultColor,
          '&:hover': {
            color: mixins.indigoDefaultColor,
            background: mixins.colorFooterBg,
            backgroundColor: mixins.colorFooterBg
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&:not(.Mui-selected):not(.Mui-disabled)': {
            opacity: 0.7
          },
          '&.Mui-selected': {
            color: 'inherit',
            opacity: 1
          },
          '&.Mui-disabled': {
            opacity: 0.38,
            color: mixins.greyBoxShadow
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          minHeight: 'unset',
          boxShadow: 'none',
          '--Paper-shadow': 'none'
        }
      }
    },
    MuiSvgIcon: {
      defaultProps: {
        fontSize: 'inherit'
      },
      styleOverrides: {
        root: {
          fontSize: 'inherit'
        }
      }
    }
  }
});

export default muiTheme;
